<template>
  <div>
    <vs-popup :active.sync="showOtherPaymentMethods" id="otherPayTypesPage">
      <vs-row vs-type="flex" vs-w="12" class="p-0 m-0">
        <vs-button color="transparent" class="payment-label bg-primary2 text-white w-full" icon-pack="feather"
          icon="icon-credit-card">
          Ödeme Seçenekleri
        </vs-button>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="info-row" v-if="activePersonal">
        <vs-col vs-type="flex" class="w-auto">
          <p class="text-primary bold mr-3">
            Personel Adı :
          </p>
          <p class="text-primary">
            {{activePersonal.name}}
          </p>
        </vs-col>
        <vs-col vs-type="flex" class="w-auto ml-auto">
          <p class="text-primary">{{currentDate}}</p>
        </vs-col>
        <vs-col vs-type="flex" class="w-auto ml-3">
          <p class="text-primary">{{currentTime}}</p>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-5">
        <vs-col vs-type="flex" vs-w="12">
          <vs-row vs-type="flex" vs-w="12">
            <vs-row vs-type="flex" vs-w="12" vs-justify="center">
              <img class="responsive w-1/4" src="@/assets/general/payment-method.svg" />
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-justify="center">
              <p class="text-primary" style="font-size:1.4vw!important;font-weight:500;">Lütfen Ödeme Yöntemini
                Seçiniz</p>
            </vs-row>
          </vs-row>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="p-5" vs-justify="center">
        <vs-col vs-type="flex" class="w-auto margin10 " vs-offset="0.5" v-for="paymentMethod in otherPaymentMethods"
          :key="paymentMethod.id">
          <vs-button @click="setSelectedChildPaymentMethod(paymentMethod);" color="transparent" :class="{'bg-success text-white' : paymentMethod.selected, 'bg-secondary' : !paymentMethod.selected}"
            class="text-primary sale-box-shadow half-friendly-border mr-2 bold" size="large">
            {{paymentMethod.name}}
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>

  <div class="payment-button-footer flex flex-nowrap overflow-x-auto justify-center items-center w-full py-1">
    <vs-button
      v-if="isPaymentBlocked" 
      @click="$emit('stop-all-timers')" 
      color="danger" 
      class="text-white sale-box-shadow half-friendly-border bg-danger mr-2 my-1 whitespace-no-wrap" 
      size="large"
    >
      Süreyi Durdur
    </vs-button>

    <!-- Kiosk Modu: Sabit Butonlar -->
    <template v-if="isKiosk">
      <vs-button
        :disabled="totalPrice == 0 || isPaymentBlocked"
        @click="setSelectedPaymentMethod({id: cashId, name: 'Nakit'})"
        color="transparent"
        class="text-white sale-box-shadow half-friendly-border bg-primary mr-2 my-1 whitespace-no-wrap kiosk-payment-btn"
        size="large"
        :class="{'bg-success' : selectedPaymentMethod && selectedPaymentMethod.id == cashId}">
        Nakit
      </vs-button>
      <vs-button
        :disabled="totalPrice == 0 || isPaymentBlocked"
        @click="setSelectedPaymentMethod({id: creditId, name: 'Kredi Kartı'})"
        color="transparent"
        class="text-white sale-box-shadow half-friendly-border bg-primary mr-2 my-1 whitespace-no-wrap kiosk-payment-btn"
        size="large"
        :class="{'bg-success' : selectedPaymentMethod && (selectedPaymentMethod.id == creditId || !selectedPaymentMethod.id)}">
        Kredi Kartı
      </vs-button>
    </template>

    <!-- Normal Mod: Dinamik Liste -->
    <template v-else>
      <vs-button
        v-show="(dontCloseCalc == false || (dontCloseCalc == true && paymentMethod.id != 4)) && ($isAdmin() || paymentMethod.id != 4)"
        :disabled="totalPrice == 0 || isPaymentBlocked"
        @click="setSelectedPaymentMethod(paymentMethod)"
        color="transparent"
        v-for="paymentMethod in standartPaymentMethods"
        :key="paymentMethod.id"
        class="text-white sale-box-shadow half-friendly-border bg-primary mr-2 my-1 whitespace-no-wrap"
        size="large"
        :class="{'bg-success' : isSelected(paymentMethod)}">
        {{paymentMethod.name}}
      </vs-button>
    </template>

    <vs-button
      v-if="hasDiscount && canResetDiscount"
      @click="$emit('reset-discount')"
      color="warning"
      class="text-white sale-box-shadow half-friendly-border bg-warning mr-2 my-1 whitespace-no-wrap"
      size="large">
      İndirim Sıfırla
    </vs-button>
  </div>
    <!--<vs-button @click="showOtherPayTypes = true" color="transparent" v-if="payType.parents!=null && payType.parents.length > 0"-->
    <!--class="text-white sale-box-shadow half-friendly-border bg-primary my-1" size="large"-->
    <!--:class="{'bg-success' : !checkForSelected.standart}">-->
    <!--{{!checkForSelected.standart ? checkForSelected.name : "Diğer"}}-->
    <!--</vs-button>-->
  </div>
</template>

<script>
  export default {
    props: {
      totalPrice: {
        type: Number,
        required: false
      },
      dontCloseCalc: {
        type: Boolean,
        required: false
      },
      currentTime: {
        type: String,
        required: true
      },
      currentDate: {
        type: String,
        required: true
      },
      isPaymentBlocked: {
        type: Boolean,
        default: false
      },
      hasDiscount: {
        type: Boolean,
        default: false
      },
      canResetDiscount: {
        type: Boolean,
        default: false
      },
      isKiosk: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        showOtherPaymentMethods: false,
      };
    },
    computed: {
      activePersonal: function () {
        return this.$store.getters["selfservice/getActivePersonal"];
      },
      paymentMethods: {
        get() {
          return this.$store.getters["selfservice/getPaymentMethods"];
        },
      },
      standartPaymentMethods() {
        const allMethods = this.$store.getters["selfservice/getPaymentMethods"];
        if (this.isKiosk) {
          // Kiosk'ta filtreyi esnetiyoruz ki ne gelirse görelim. 
          // Boş objeleri ve İndirim (4)/Cari (10) gibi gereksizleri gizleyelim.
          return allMethods.filter(x => x && x.id && x.name && x.id != 4 && x.id != 10);
        }
        return allMethods.filter(x => x.type != 'Single');
      },
      otherPaymentMethods() {
        return this.$store.getters["selfservice/getPaymentMethods"].filter(x => x.originPaymentMethodId == this.$othersPaymentId);
      },
      selectedPaymentMethod: {
        get() {
          return this.$store.getters["selfservice/getSelectedPaymentMethod"];
        },
        set(val) {
          this.$store.dispatch("selfservice/setSelectedPaymentMethod", val);
        }
      },
      cashId() {
        return process.env.VUE_APP_CASH_PAYMENT_ID ? parseInt(process.env.VUE_APP_CASH_PAYMENT_ID) : 1;
      },
      creditId() {
        return process.env.VUE_APP_CREDIT_PAYMENT_ID ? parseInt(process.env.VUE_APP_CREDIT_PAYMENT_ID) : 2;
      }
    },
    watch: {
      showOtherPaymentMethods(val, oldVal) {
        if (oldVal == true && val == false && this.dontCloseCalc == true) {
          this.$emit("dontClose");
        }
      }
    },
    methods: {
      isSelected(method){
        if(method.selected == true || this.paymentMethods.filter(x=> x.originPaymentMethodId == method.id).some(y=> y.selected == true)) return true;
        else return false;
      },
      setSelection(paymentMethod) {
        this.selectedPaymentMethod = paymentMethod;
        this.$emit('payment-selected', paymentMethod);
      },
      setSelectedChildPaymentMethod(paymentMethod) {
        if (
          paymentMethod.id == 4 ||
          paymentMethod.id == 15 ||
          (paymentMethod.name &&
            paymentMethod.name.toLowerCase().includes("indirim"))
        ) {
          this.$emit("open-discount");
          this.showOtherPaymentMethods = false;
          return;
        }
        this.setSelection(paymentMethod);
        this.showOtherPaymentMethods = false;
      },

      setSelectedPaymentMethod(method) {
        if (
          method.id == 4 ||
          method.id == 15 ||
          (method.name && method.name.toLowerCase().includes("indirim"))
        ) {
          this.$emit("open-discount");
          return;
        }
        if (this.paymentMethods.some((x) => x.originPaymentMethodId == method.id))
          this.showOtherPaymentMethods = true;
        else this.setSelection(method);
      },
    }
  };

</script>

<style>
  .margin10 {
    margin-bottom: 10px !important;
  }
   #otherPayTypesPage .vs-popup .vs-popup--header {
    display: none;
  }

  #otherPayTypesPage .vs-popup .vs-popup--content {
    padding: 0 !important;
    margin: 0 !important;
    width: 100%;
  }

  #otherPayTypesPage .vs-popup {
    border-radius: 2rem !important;
  }

  .payment-button-footer {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
  }
  .payment-button-footer::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
  
  /* Mobilde eğer sığmazsa sola yasla (scroll için), sığarsa ortala */
  @media (max-width: 768px) {
    .payment-button-footer {
      justify-content: flex-start !important;
      padding-left: 10px;
      padding-right: 10px;
    }
  }
</style>
